import { ButtonIcon, ButtonSize, ButtonVariant, IconVariants, Shape, Text, TextVariants, useMedia } from "@next-platform/client-common-spicy-ui";
import { useHits } from "react-instantsearch";

import { FEATURES_CATEGORY, TAGS_CATEGORY, TRANSLATED_LANGUAGES_CATEGORY } from "./FilterBox/constants";
import { SearchTagFilterTriggerProps } from "./types";
import useSearchFilterPanelToggle from "./useSearchFilterPanelToggle";

const getFilterCount = (results: ReturnType<typeof useHits>["results"]) =>
  [TAGS_CATEGORY, TRANSLATED_LANGUAGES_CATEGORY, FEATURES_CATEGORY].reduce(
    (count, category) => count + (results?._state?.facetsRefinements?.[category]?.length ?? 0),
    0,
  );

export default function SearchTagFilterTrigger({
  tagListMinimized,
  setTagListMinimized,
  setTagsDrawer,
  onlyDesktop = false,
  notDesktop = false,
}: SearchTagFilterTriggerProps) {
  const { isDesktop } = useMedia();
  const { results } = useHits();
  const filterCount = getFilterCount(results);
  const handleTogglePanel = useSearchFilterPanelToggle({ tagListMinimized, setTagListMinimized, setTagsDrawer });

  if (onlyDesktop && !isDesktop) {
    return null;
  }
  if (notDesktop && isDesktop) {
    return null;
  }
  return (
    <div className="relative w-max" onClick={handleTogglePanel}>
      <ButtonIcon
        className={`!w-[46px] ${!tagListMinimized && isDesktop && "!border-2 !border-solid !border-[#0072F5]"}`}
        icon={IconVariants.SLIDER_HORIZONTAL}
        variant={ButtonVariant.OUTLINED}
        shape={Shape.SQUARE}
        size={ButtonSize.MEDIUM}
        aria-label="filter"
      />

      {filterCount > 0 && (
        <div className="bg-black dark:bg-white size-4 text-white dark:text-black grid place-items-center rounded-full absolute -top-0.5 -right-0.5 z-10">
          <Text variant={TextVariants.LABEL_SMALL_REGULAR}>{filterCount}</Text>
        </div>
      )}
    </div>
  );
}
